import type { EventBus } from "./eventBus";
import type { SessionEvent } from "./eventSchema";

// barge-in 調査 (2026-07-25): 実機で「AI 発話中に話しても入力が反応しない」を切り分けるための
// 診断計装。?event-debug=1 のときだけ、eventBus に流れる全イベント (vad.speech_start /
// bargein.detected / wss.* / scribe.*) と continuous mode の分岐判断を console に出す。
//
// events.jsonl は R2 に残るが、実機で 1 回再現して即読むには DevTools の console が速い。
// また「onSpeechEnd を TTS 再生中と判定して破棄した」は events に残らない (破棄の事実自体が
// イベント化されていない) ため、dlog がその唯一の観測点になる。
//
// フラグ判定を module-top const にせず関数内で読むのは、テストが history.replaceState で
// search を差し替えられるようにするため (useContinuousMode の
// readFilterBackgroundAudioFromEnv と同じ理由)。

function isEnabled(): boolean {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get("event-debug") === "1";
}

/**
 * eventBus に流れる全イベントを console に出す subscriber を登録する。
 * フラグが無ければ購読自体を行わない (production は完全に無音)。
 * 返り値を呼ぶと購読解除する。
 */
export function attachEventDebugLogger(bus: EventBus): () => void {
  if (!isEnabled()) return () => undefined;
  return bus.subscribe((event: SessionEvent) => {
    console.info(`[event] ${event.timestamp} ${event.type}`, event.payload);
  });
}

/** ?event-debug=1 のときだけ console に出す診断ログ (既定は無音)。 */
export function dlog(...args: unknown[]): void {
  if (!isEnabled()) return;
  console.info("[continuous]", ...args);
}
